import { IRecommendationTrackSource } from '@epicuro-next/models/recommendation-panels';
import { createAction, props } from '@ngrx/store';

export const recommendationUrlRedirect = createAction(
  '[Recommendation] Url Redirect',
  props<
    Partial<IRecommendationTrackSource> & {
      routerLink: string;
    }
  >(),
);
